import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  Avatar,
  Card,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  // requiredArrayValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";

import FormImageUpload from "../../components/formFields/FormImageUpload";
import {
  createWeekendgateways,
  deleteWeekendgatewaysImage,
  getWeekendgatewaysByID,
  updateWeekendgateways,
  WeekendgatewaysImageUpload,
} from "./services/weekendgateways.services";

import { ISector } from "../sector/sectorModel";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import { clearWeekendgatewaysDetails } from "./weekendgatewaysSlice";
import { STARRATING } from "../../_contstants/common";
import { Label } from "@progress/kendo-react-labels";

import { FaEye } from "react-icons/fa6";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormTextArea from "../../components/formFields/FormTextArea";
import { getAllActiveActivities } from "../activity/service/activity.services";
import { IActivity } from "../activity/activityModel";
import FormMultiSelectionFiled from "../../components/formFields/FormMultiSelectionFiled";
import { getAllActiveSectors } from "../sector/services/sector.services";
import IconComponent from "../../components/common/IconComponent";

const CreateWeekendgateways: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const WeekendgatewaysID = location.state?.WeekendgatewaysID;
  const WeekendgatewaysDetail = useAppSelector(
    (state) => state.weekendgateways.WeekendgatewaysDetail
  );

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [WeekendgatewaysDetail]);

  const loading = useAppSelector((state) => state.weekendgateways.loading);
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const ActivityList = useAppSelector((state) => state.activity.ActivityList);

  useEffect(() => {
    if (WeekendgatewaysID) {
      dispatch(getWeekendgatewaysByID(WeekendgatewaysID));
    }
  }, [WeekendgatewaysID]);

  useEffect(() => {
    dispatch(getAllActiveSectors());
    dispatch(getAllActiveActivities());
    return () => {
      dispatch(clearWeekendgatewaysDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    const formData = {
      Name: values.Name ?? "",
      DisplayName: values.DisplayName ?? "",
      ShortDescription: values.ShortDescription ?? "",
      LongDescription: values.LongDescription ?? "",
      NoofNights: values.NoofNights ? values.NoofNights : null,
      Description: values.Description ?? "",
      Star: values.Star ? +values.Star : null,
      MetaTitle: values.MetaTitle ?? "",
      MetaKeywords: values.MetaKeywords ?? "",
      MetaDescription: values.MetaDescription ?? "",
      DestinationID: values.DestinationID ? values.DestinationID : null,
      PerCoupleRate: values.PerCoupleRate ? +values.PerCoupleRate : 0,
      ExtraAdultRate: values.ExtraAdultRate ? +values.ExtraAdultRate : 0,
      ExtraChildRateWithoutBed: values.ExtraChildRateWithoutBed
        ? +values.ExtraChildRateWithoutBed
        : 0,
      ExtraChildRateWithBed: values.ExtraChildRateWithBed
        ? +values.ExtraChildRateWithBed
        : 0,
      SpecialRate: values.SpecialRate ? +values.SpecialRate : 0,
      Inclusions: values.Inclusions ?? "",
      TourInfo: values.TourInfo ?? "",
      Activities: values.Activities ?? "",
      ActivityID: values.ActivityID ? values?.ActivityID?.join(",") : "",
      FromDate: values.FromDate
        ? moment(values.FromDate).format("YYYY-MM-DD")
        : null,
      ToDate: values.ToDate ? moment(values.ToDate).format("YYYY-MM-DD") : null,
      // CWBRate: values.CWBRate ? +values.CWBRate : 0,
      // CoupleRate: values.CoupleRate ? +values.CoupleRate : 0,
      // CNBRate: values.CNBRate ? +values.CNBRate : 0,
      IsActive: values.IsActive === 1,
    };

    const ImageData = new FormData();
    const MainImage =
      values?.MainImage && typeof values?.MainImage !== "string"
        ? values?.MainImage[0]?.getRawFile()
        : "";

    // Handle Multiple Inner Images (Check if it's a new file or an existing URL)
    if (values?.InnerImage && Array.isArray(values.InnerImage)) {
      values.InnerImage.forEach((image: any) => {
        if (image.InnerImage && typeof image.InnerImage === "string") {
          // Skip existing image URLs
          return;
        }

        const file = image instanceof File ? image : image?.getRawFile();
        if (file) {
          ImageData.append("InnerImage", file); // Append only new images
        }
      });
    }
    try {
      if (WeekendgatewaysID) {
        const editPayload = { ...formData, ID: WeekendgatewaysID };
        const response = await dispatch(updateWeekendgateways(editPayload));

        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            (values?.MainImage && typeof values?.MainImage !== "string") ||
            ImageData.has("InnerImage")
          ) {
            ImageData.append("WeekendGatewayID", WeekendgatewaysID);
            ImageData.append("MainImage", MainImage);
            await dispatch(WeekendgatewaysImageUpload(ImageData));
          }
          navigate("/weekendgateways");
        }
      } else {
        const response = await dispatch(createWeekendgateways(formData));

        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            (values?.MainImage && typeof values?.MainImage !== "string") ||
            ImageData.has("InnerImage")
          ) {
            ImageData.append("WeekendGatewayID", response?.payload?.Data?.ID);
            ImageData.append("MainImage", MainImage);
            await dispatch(WeekendgatewaysImageUpload(ImageData));
          }
          navigate("/weekendgateways");
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleDeleteImage = async (ID: number) => {
    try {
      const response = await dispatch(deleteWeekendgatewaysImage(ID));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(getWeekendgatewaysByID(WeekendgatewaysID));
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  type DocViewProps = {
    InnerImage: string;
  };

  const DocView: React.FC<DocViewProps> = (props) => {
    const handleOnEditClick = () => {
      window.open(props.InnerImage, "_blank");
    };
    return (
      <Button
        type="button"
        fillMode="flat"
        size="large"
        onClick={handleOnEditClick}
      >
        <IconComponent icon={FaEye} style={{ color: "red" }} />
      </Button>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          onSubmit={handleSubmit}
          key={formKey}
          initialValues={WeekendgatewaysDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <ShadowCard style={{ padding: 12 }}>
                <GridLayout
                  style={{ marginRight: 40 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4>
                      {WeekendgatewaysID
                        ? "Update Weekend Gateways"
                        : "Add Weekend Gateways"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="Name"
                      label="Name"
                      placeholder="Name"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"DestinationID"}
                      name={"DestinationID"}
                      label={"Sector"}
                      placeholder="Select Sector"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={SectorList?.map((sector: ISector) => {
                        return {
                          value: sector?.ID,
                          label: sector?.SectorName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="DisplayName"
                      label="Display Name"
                      placeholder="Display Name"
                      component={FormTextField}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="NoofNights"
                      label="No of Nights"
                      placeholder="No of Nights"
                      type="number"
                      component={FormTextField}
                    />
                  </GridLayoutItem>

                  {/* <GridLayoutItem>
                    <Field
                      name="Star"
                      label="Star"
                      placeholder="Star"
                      component={FormTextField}
                    />
                  </GridLayoutItem> */}
                  <GridLayoutItem style={{ width: "100%" }}>
                    <Field
                      name={"Star"}
                      label={"Star Rating"}
                      placeholder={"Star Rating"}
                      component={FormSelectionField}
                      options={STARRATING?.map((rating: any) => {
                        return {
                          value: rating?.value,
                          label: rating?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="PerCoupleRate"
                      label="Per Couple Rate"
                      type="number"
                      placeholder="0"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="ExtraAdultRate"
                      label="Extra Adult Rate"
                      type="number"
                      placeholder="0"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="ExtraChildRateWithoutBed"
                      label="Extra Child Rate Without Bed"
                      type="number"
                      placeholder="0"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="ExtraChildRateWithBed"
                      label="Extra Child Rate With Bed"
                      placeholder="0"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="SpecialRate"
                      label="Special Rate"
                      placeholder="0"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"ActivityID"}
                      name={"ActivityID"}
                      label={"Activities"}
                      placeholder="Select Activities"
                      component={FormMultiSelectionFiled}
                      // validator={requiredArrayValidator}
                      // astrike={true}
                      options={ActivityList?.map((activity: IActivity) => {
                        return {
                          value: activity?.ID,
                          label: activity?.ActivityName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    {/* <Field
                      name="Activities"
                      label="Activities"
                      placeholder="Activities"
                      component={FormTextField}
                    /> */}
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="FromDate"
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="ToDate"
                      label="To Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={4}>
                    <Field
                      name="MetaTitle"
                      label="Meta Title"
                      placeholder="Meta Title"
                      component={FormTextField}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem colSpan={4}>
                    <Field
                      name="MetaKeywords"
                      label="Meta Keywords"
                      placeholder="Meta Keywords"
                      component={FormTextField}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem colSpan={4}>
                    <Field
                      name="MetaDescription"
                      label="Meta Description"
                      placeholder="Meta Description"
                      component={FormTextArea}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="TourInfo"
                      label="Tour Info"
                      placeholder="Tour Info"
                      component={FormRichTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="Inclusions"
                      label="Inclusions"
                      placeholder="Inclusions"
                      component={FormRichTextField}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="Description"
                      label="Description"
                      component={FormRichTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="ShortDescription"
                      label="Short Description"
                      component={FormRichTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      justifyContent="start"
                      name={`MainImage`}
                      label="Main Image"
                      type="file"
                      accept="image/*"
                      alternateName="Main Image"
                      component={FormImageUpload}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      justifyContent="start"
                      name="InnerImage"
                      label="Inner Images"
                      type="file"
                      accept="image/*"
                      alternateName="Inner Images"
                      component={FormImageUpload}
                      multiple
                    />
                  </GridLayoutItem>

                  {WeekendgatewaysDetail.InnerImages &&
                    WeekendgatewaysDetail.InnerImages.length > 0 && (
                      <GridLayoutItem colSpan={4}>
                        <Label
                          id={"attachment-label"}
                          // editorId={id}
                          className="k-form-label field-label"
                          style={{
                            marginTop: "14px",
                            marginLeft: 5,
                          }}
                        >
                          {"Inner Images List"}
                        </Label>
                        <GridLayout
                          style={{
                            marginRight: "50px",
                          }}
                          cols={[
                            {
                              width: "16.66%",
                            },
                            {
                              width: "16.66%",
                            },
                            {
                              width: "16.66%",
                            },
                            {
                              width: "16.66%",
                            },
                            {
                              width: "16.66%",
                            },
                            {
                              width: "16.66%",
                            },
                          ]}
                          gap={{
                            cols: 10,
                            rows: 10,
                          }}
                        >
                          {WeekendgatewaysDetail.InnerImages.map(
                            (weekendgateways: any) => (
                              <GridLayoutItem>
                                <Card
                                  style={{
                                    boxShadow:
                                      "4px 4px 20px 4px rgb(0 0 0 / 5%)",
                                  }}
                                >
                                  <GridLayout
                                    cols={[
                                      {
                                        width: "100%",
                                      },
                                    ]}
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    <GridLayoutItem
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Avatar
                                        style={{
                                          width: 45,
                                          height: 45,
                                          flexBasis: 45,
                                        }}
                                        rounded={"full"}
                                        type={"image"}
                                      >
                                        <img
                                          src={weekendgateways.InnerImage}
                                          alt="Inner"
                                          width={200}
                                          height={200}
                                        />
                                      </Avatar>
                                      <DocView
                                        InnerImage={weekendgateways.InnerImage}
                                      />

                                      <IconButton
                                        type="button"
                                        fillMode="flat"
                                        size="large"
                                        onClick={() =>
                                          handleDeleteImage(weekendgateways.ID)
                                        }
                                        icon={MdDelete}
                                        iconClassName="absolute-position"
                                        iconStyle={{ fontSize: "24px" }}
                                      />
                                    </GridLayoutItem>
                                  </GridLayout>
                                </Card>
                              </GridLayoutItem>
                            )
                          )}
                        </GridLayout>
                      </GridLayoutItem>
                    )}

                  <GridLayoutItem
                    colSpan={4}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={WeekendgatewaysID ? "Update" : "Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/weekendgateways")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateWeekendgateways;
